import api from './api';

const alertService = {
  // Get all alerts (paginated)
  getAlerts: (params = {}) => {
    return api.get('/v1/alerts/alerts/', { params });
  },

  // Get single alert
  getAlert: (id) => {
    return api.get(`/v1/alerts/alerts/${id}/`);
  },

  // Get unread count for badge
  getUnreadCount: () => {
    return api.get('/v1/alerts/alerts/unread_count/');
  },

  // Mark single alert as read
  markRead: (id) => {
    return api.post(`/v1/alerts/alerts/${id}/mark_read/`);
  },

  // Mark all alerts as read
  markAllRead: () => {
    return api.post('/v1/alerts/alerts/mark_all_read/');
  },

  // Dismiss an alert
  dismiss: (id) => {
    return api.post(`/v1/alerts/alerts/${id}/dismiss/`);
  },
};

export default alertService;
